import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class TenantBankAccount<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: name */
  name?: string;
  /** Alias: accountOwner */
  accountOwner?: string;
  /** Alias: mainAccount */
  mainAccount?: boolean;
  /** Alias: iBAN */
  iban?: string;
  /** Alias: bIC */
  bic?: string;
  /** Alias: sEPACreditorId */
  sepaCreditorId?: string;
  /** Alias: ledgerAccount */
  ledgerAccount?: string;

  __typename?: string;
}

const fields: FieldDefinitions<TenantBankAccount> = {
  id: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  accountOwner: {
    alias: 'accountOwner',
  },
  mainAccount: {
    alias: 'mainAccount',
  },
  iban: {
    alias: 'iBAN',
  },
  bic: {
    alias: 'bIC',
  },
  sepaCreditorId: {
    alias: 'sEPACreditorId',
  },
  ledgerAccount: {
    alias: 'ledgerAccount',
  },
  __typename: {
    alias: '__typename',
  },
};

export const tenantBankAccountEntityDefinition: EntitiyDefinition<TenantBankAccount> =
  {
    local: {},
    remote: {
      queryName: 'getTenantBankAccounts',
      fragmentName: 'TenantBankAccount',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
